export default {
  title: '倉庫資料',
  schema: {
    type: 'Object',
    contents: {
      key: {
        label: '倉庫編號',
        type: 'String',
        unique: true,
        required: true,
      },
      name: {
        label: '倉庫名稱',
        type: 'String',
        unique: true,
        required: true,
      },
      '@order': {
        name: '排序',
        type: 'Number',
      },
      contact: { type: 'String', label: '聯絡人' },
      phone: { type: 'String', label: '電話' },
      email: { type: 'String', label: 'Email' },
      fax: { type: 'String', label: '傳真' },
      address: { type: 'String', label: '地址' },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  list: {
    ui: {
      fields: ['key', 'name', '@order'],
    },
  },
  ui: {
    editor: {
      config: { nameWidth: 120 },
      groups: [
        {
          name: '',
          rows: [[{ key: 'key' }], [{ key: 'name' }]],
        },
      ],
    },
  },
}
